'use client';

import { useState } from 'react';

import { FormattedMessage } from '@flipster/i18n';
import { createSingleChoice } from '@flipster/react/design-system/chip';
import { css } from '@flipster/styled-system/css';
import { stack } from '@flipster/styled-system/patterns';

import { FaqTab } from './tab-faq';
import { FeeTab } from './tab-fee';
import { HowItWorksTab } from './tab-how-it-works';
import { RisksTab } from './tab-risks';

type TabId = 'how-it-works' | 'fee' | 'risks' | 'faq';

const TabChips = createSingleChoice<TabId>();

export const InfoTabs = () => {
  const [activeTab, setActiveTab] = useState<TabId>('how-it-works');

  return (
    <section className={stack({ tabletDown: { gap: 20 }, tablet: { gap: 24 } })}>
      <TabChips value={activeTab} onChange={setActiveTab}>
        <TabChips.Chip value='how-it-works' label={<FormattedMessage id='Earn.r260224.How_it_works' />} />
        <TabChips.Chip value='fee' label={<FormattedMessage id='Common.r251204.Fee' />} />
        <TabChips.Chip value='risks' label={<FormattedMessage id='Earn.r260224.Risks' />} />
        <TabChips.Chip value='faq' label={<FormattedMessage id='Common.r251107.Faq' />} />
      </TabChips>

      <div className={css({ minH: 200 })}>
        {activeTab === 'how-it-works' && <HowItWorksTab />}
        {activeTab === 'fee' && <FeeTab />}
        {activeTab === 'risks' && <RisksTab />}
        {activeTab === 'faq' && <FaqTab />}
      </div>
    </section>
  );
};
